import type { IAccount } from "@/modules/account/common/types";
import { bankNames } from "@/modules/transaction/common/constants";
import type { BankAccountPrefix } from "@/modules/transaction/common/enum";
import { getAccountOptions } from "@/modules/transaction/helpers";

interface IGetAccountFilteredOptionsProps {
  accountsList: IAccount[];
  accountFilters: string[];
}

export const getAccountsFilteredList = ({
  accountsList,
  accountFilters,
}: IGetAccountFilteredOptionsProps) => {
  return getAccountOptions({ accountsList })
    .filter((item) => accountFilters?.includes(item?.meta?.currency));
};

export const getBankName = (account?: string) => {
  const PREFIX_LENGTH = 3;
  const prefix = account?.slice(0, PREFIX_LENGTH) as BankAccountPrefix;
  return bankNames[prefix] || "";
};
